export default __webpack_public_path__ + "static/media/ngo-a035-3.5a56dfa7.jpg";